import {Route} from "@angular/router";
import {customerUserGuard} from "../shared/guards/customer-user.guard";
import {languageGuard} from "../shared/guards/language.guard";
import {passwordChangeEnforcementGuard} from "../shared/guards/password-change-enforcement.guard";
import {CommunityDiscussionsdComponent} from "../templates/community-discussionsd/community-discussionsd.component";
import {CommunityTopicsdComponent} from "../templates/community-topicsd/community-topicsd.component";
import {CommunitysdComponent} from "../templates/communitysd/communitysd.component";
import {FeedbackDisplaySdComponent} from "../templates/feedback-display-sd/feedback-display-sd.component";
import {FeedbackSDComponent} from "../templates/feedback-sd/feedback-sd.component";
import {FeedbackStatsSdComponent} from "../templates/feedback-stats-sd/feedback-stats-sd.component";
import {WorkflowsSDCreate} from "../templates/workflows-createsd/workflows-createsd.component";
import {WorkflowsStageTodoSdComponent} from "../templates/workflows-stage-todo-sd/workflows-stage-todo-sd.component";
import {WorkflowsSDComponent} from "../templates/workflowssd/workflowssd.component";


export const templateRoutes: Route[] = [
  {
    path: "workflowsd",
    component: WorkflowsSDComponent,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
  {
    path: "workflows-createsd",
    component: WorkflowsSDCreate,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
  {
    path: "workflows-stage-todo-sd",
    component: WorkflowsStageTodoSdComponent,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
  {
    path: "communitysd",
    component: CommunitysdComponent,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
  {
    path: "community-topicsd",
    component: CommunityTopicsdComponent,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
  {
    path: "community-discussionsd",
    component: CommunityDiscussionsdComponent,
    canActivate: [languageGuard, customerUserGuard]
  },
  {
    path: "feedbacksd",
    component: FeedbackSDComponent,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
  {
    path: "feedback-displaysd",
    component: FeedbackDisplaySdComponent,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
  {
    path: "feedback-statssd",
    component: FeedbackStatsSdComponent,
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard]
  },
]